import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { applySeo } from '../seo/tags';

/* Catch-all route. nginx serves the prerendered copy of this page (404.html)
 * with HTTP 404 for unknown paths, so search engines drop dead URLs instead of
 * indexing the home page under them (the "soft 404" the SPA fallback used to
 * produce). Client-side it also answers typos in the address bar. */
const NotFound: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    applySeo({
      title: 'Page not found | TrueLog',
      description: 'The page you are looking for does not exist or has moved.',
      noindex: true,
    });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-slate-50 px-4 pb-24 pt-32 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl rounded-[34px] border border-slate-200/80 bg-white p-10 text-center shadow-[0_28px_70px_-42px_rgba(15,23,42,0.22)]">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0E9ED5]">Error 404</p>
        <h1 className="mt-4 text-4xl font-bold tracking-tight text-slate-950">Page not found</h1>
        <p className="mt-4 text-sm leading-7 text-slate-600">
          The page you are looking for does not exist or has moved. Check the address, or start again from one of
          the pages below.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-2xl bg-[#0E9ED5] px-6 py-3 text-sm font-bold uppercase tracking-[0.14em] text-white transition-colors hover:bg-[#0b7aa6]"
          >
            <ArrowLeftIcon className="h-4 w-4" />
            Home
          </Link>
          <Link
            to="/services"
            className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 px-6 py-3 text-sm font-bold uppercase tracking-[0.14em] text-slate-700 transition-colors hover:border-[#0E9ED5] hover:text-[#0E9ED5]"
          >
            Services
          </Link>
          <Link
            to="/contact-us"
            className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 px-6 py-3 text-sm font-bold uppercase tracking-[0.14em] text-slate-700 transition-colors hover:border-[#0E9ED5] hover:text-[#0E9ED5]"
          >
            Contact us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
